import WarningIconMessage from './WarningIconMessage';

export default WarningIconMessage;
